module.exports = __webpack_public_path__ + "static/media/AlreadyProcessed.32c877ea.svg";